const DOCUMENT_TYPE_LABELS = {
  ConsignmentNote: "Транспортная накладная",
  ForwarderOrder: "Поручение экспедитору",
  ForwarderReceipt: "Экспедиторская расписка",
  TransportOrder: "Заказ-заявка на перевозку",
};

const PROVIDER_LABELS = {
  saby: "Saby",
  taxcom: "Такском",
  kontur: "Контур",
};

export function edoDocumentTypeLabel(type) {
  if (type && typeof type === "object") {
    const resolvedType = edoDocumentResolvedType(type);
    return DOCUMENT_TYPE_LABELS[resolvedType] || forwardingDocumentTypeName(type) || type.document_type_name || type.document_type || "—";
  }

  return DOCUMENT_TYPE_LABELS[type] || type || "—";
}

export function edoProviderLabel(provider) {
  return PROVIDER_LABELS[provider] || provider || "—";
}

export function edoDocumentResolvedType(document) {
  const type = document?.document_type;
  if (type !== "ForwarderESD") return type;

  return forwardingDocumentType(document) || type;
}

function forwardingDocumentType(document) {
  for (const marker of forwardingDocumentMarkers(document)) {
    if (marker === "Поручение экспедитору" || marker === "ПоручениеЭкспедитору") {
      return "ForwarderOrder";
    }
    if (marker === "Экспедиторская расписка" || marker === "ЭкспедиторскаяРасписка") {
      return "ForwarderReceipt";
    }
    if (["1110486", "1110487"].includes(String(marker))) {
      return "ForwarderOrder";
    }
    if (String(marker) === "1110489") {
      return "ForwarderReceipt";
    }
  }

  return null;
}

function forwardingDocumentTypeName(document) {
  for (const marker of forwardingDocumentMarkers(document)) {
    if (marker === "Поручение экспедитору" || marker === "ПоручениеЭкспедитору") {
      return "Поручение экспедитору";
    }
    if (marker === "Отзыв поручения экспедитору" || marker === "ОтзывПорученияЭкспедитору") {
      return "Отзыв поручения экспедитору";
    }
    if (marker === "Экспедиторская расписка" || marker === "ЭкспедиторскаяРасписка") {
      return "Экспедиторская расписка";
    }
    if (marker === "Складская расписка" || marker === "СкладскаяРасписка") {
      return "Складская расписка";
    }
    if (["1110486", "1110487"].includes(String(marker))) {
      return "Поручение экспедитору";
    }
    if (String(marker) === "1110488") {
      return "Отзыв поручения экспедитору";
    }
    if (String(marker) === "1110489") {
      return "Экспедиторская расписка";
    }
    if (String(marker) === "1110490") {
      return "Складская расписка";
    }
  }

  return null;
}

function forwardingDocumentMarkers(document) {
  const markers = [
    document.document_type_name,
    forwardingRegulationName(document.raw_data),
    ...forwardingAttachmentMarkers(document.raw_data),
  ].filter(Boolean);

  return markers;
}

function forwardingRegulationName(rawData) {
  const payload = remoteDocumentPayload(rawData);
  const regulation = Array.isArray(payload?.Регламент)
    ? payload.Регламент[0]
    : payload?.Регламент;

  return regulation && typeof regulation === "object" ? regulation.Название : null;
}

function forwardingAttachmentMarkers(rawData) {
  const payload = remoteDocumentPayload(rawData);
  const attachments = Array.isArray(payload?.Вложение)
    ? payload.Вложение
    : [payload?.Вложение].filter(Boolean);

  return attachments.flatMap((attachment) => {
    if (!attachment || typeof attachment !== "object") return [];
    return [attachment.Тип, attachment.Подтип, attachment.КНД].filter(Boolean);
  });
}

function remoteDocumentPayload(rawData) {
  if (!rawData || typeof rawData !== "object") return {};
  if (Array.isArray(rawData.Документ)) return rawData.Документ[0] || {};
  if (rawData.Документ && typeof rawData.Документ === "object") return rawData.Документ;
  return rawData;
}
